import { routes as InsuranceRequestRoutes } from '@views/InsuranceRequest/routes'
// eslint-disable-next-line import/prefer-default-export
export const routes = [
  // InsuranceRequest
  {
    path: 'basePath',
    alias: 'motorbikeBasePath', // Motorbike has its' own URL
    name: 'InsuranceRequest',
    component: () => import('@views/InsuranceRequest'),
    redirect: {
      name: 'InsuranceRequestStart',
    },
    children: InsuranceRequestRoutes,
  },
  // Maintenance Page / Wartungsseite
  {
    path: 'basePath/maintenance',
    name: 'Maintenance',
    component: () => import('@views/Maintenance'),
  },
  // Components Page / Styleguide
  {
    path: 'basePath/playground',
    name: 'Playground',
    component: () => import('@views/Playground'),
  },
]
